const FILTERS_BLACKLIST = [
]

const RANGE_INDICATOR = '<->'

const PRICE_FILTER_FIELD = 'ss_price'

const parseFiltersFromResults = (results) => {
  if (!results?.facets) return { fetchedFilters: [], sizeFilters: [] }
  const whiteListedFilters = results.facets.filter((facet) => {
    return !FILTERS_BLACKLIST.some((field) => field === facet.field)
  })
  return whiteListedFilters
}
export { parseFiltersFromResults, PRICE_FILTER_FIELD, RANGE_INDICATOR }
